

import { NumberUtil } from "../../../utils/number";
import { BillingService } from "../../../services/BillingService";
import { useEffect, useState, useMemo } from "react";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useSession } from "../../../hooks/useSession";
import { useTranslation } from "react-i18next";
import { AlertService } from '../../../services/Alert'
import useAccounts from '../../../hooks/useAccounts';
import Aside from "../../../components/Aside";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import CustomDataTable from "../../../components/CustomDataTable";
import DatePicker from "../../../components/form-controls/DatePicker";
import LineChart from "../../../components/LineChart"
import SimpleLineChart from "../../../components/SimpleLineChart"
import LoaderSmall from "../../../components/LoaderSmall"
import Select from 'react-select'
import useRequest from "../../../hooks/useRequest";
import moment from 'moment';

function BillingPage() {
    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const { accounts } = useAccounts();
    const { session } = useSession();
    const { call, isRequesting } = useRequest();
    const heightRequesting = useMemo(() => { return isRequesting ? 'h-200' : '' }, [isRequesting]);
    const [dataRoot, setDataRoot] = useState([])
    const [data, setData] = useState([])
    const [dataRCS, setDataRCS] = useState([])
    const [filterRangeDates, setFilterRangeDates] = useState({ start: null, end: null })
    const [conversations, setConversations] = useState([])
    const [totalCampaigns, setTotalCampaigns] = useState(0)
    const [totalCamp, setTotalCamp] = useState(0)
    const [totalTargets, setTotalTargets] = useState(0)
    const [totalApi, setTotalApi] = useState(0)
    const [totalChat, setTotalChat] = useState(0)
    const [activeTab, setActiveTab] = useState('tabOne');
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [datePickerKey, setDatePickerKey] = useState(0);
    const [dataTargets, setDataTargets] = useState({
        campaign: { total: 0, data_points: {} },
        api: { total: 0, data_points: {} },
        chats: { total: 0, data_points: {} },
    });
    const [dataTags, setDataTags] = useState({
        labels: [],
        dataPoints: {}
    });

    const getColumnDefinition = (name: string, dataKey: string) => ({
        name: name,
        sortable: false,
        center: false,
        cell: (row: any) => {
            const tableData = row.table && row.table[dataKey] ? row.table[dataKey] : null;

            const percentage = tableData && tableData.persent === 0
                ? "0"
                : (tableData?.persent || t("bulk-senders.data-no-info"));
            const badgeClass = percentage === "0"
                ? "badge bg-soft-warning text-warning"
                : parseFloat(percentage) < 0
                    ? "badge bg-soft-danger text-danger"
                    : "badge bg-soft-primary text-primary";
            const iconClass = percentage === "0"
                ? ""
                : parseFloat(percentage) < 0
                    ? "bi bi-graph-down-arrow"
                    : "bi bi-graph-up-arrow";

            return (
                <div className="text-left">
                    <p className="mb-1 text-nowrap">
                        <span className="h4">{t("reports.billing.currently")}: </span> <span className="fs-4">{tableData?.currently ?? 0}</span>
                    </p>
                    <p className="mb-0 text-nowrap">
                        <span className="h4">{t("reports.billing.currently_cost")}: </span> <span className="fs-4">${NumberUtil.format(tableData?.currently_cost ?? 0)}</span>
                    </p>
                    <p className="mb-0 text-nowrap">
                        <span className="h4">{t("reports.billing.last")}: </span> <span className="fs-4">{tableData?.last ?? 0}</span>
                    </p>
                    <p className="mb-0 text-nowrap">
                        <span className="h4">{t("reports.billing.last_cost")}: </span> <span className="fs-4">${NumberUtil.format(tableData?.last_cost ?? 0)}</span>
                    </p>
                    <p className="mb-0 text-nowrap">
                        <span className="h4">{t("reports.billing.percent")}: </span>
                        <span className={`fs-4 ${badgeClass}`}>
                            {percentage}% {iconClass && <i className={iconClass}></i>}
                        </span>
                    </p>
                </div>
            );
        }
    });

    const columnsRoot = [
        {
            name: t("reports.billing.data"),
            sortable: false,
            center: false,
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <p className="mb-1 text-nowrap">
                            <span className="h4">{t("reports.billing.account")}: </span> <span className="fs-4">{row.account}</span>
                        </p>
                        <p className="mb-0 text-nowrap">
                            <span className="h4">{t("reports.billing.client")}: </span> <span className="fs-4">{row.account_client}</span>
                        </p>
                    </div>
                )
            }
        },
        getColumnDefinition(t("reports.billing.mkt"), 'MARKETING'),
        getColumnDefinition(t("reports.billing.utility"), 'UTILITY'),
        getColumnDefinition(t("reports.billing.auth"), 'AUTHENTICATION'),
        getColumnDefinition(t("reports.billing.service"), 'SERVICE'),
    ];

    const columns = [
        {
            name: t("reports.billing.type_conersations"),
            sortable: false,
            center: false,
            cell: (row: any) => {
                let type = "";

                switch (row.type) {
                    case "AUTHENTICATION":
                        type = t("reports.billing.auth");
                        break;
                    case "MARKETING":
                        type = t("reports.billing.mkt");
                        break;
                    case "SERVICE":
                        type = t("reports.billing.service");
                        break;
                    case "UTILITY":
                        type = t("reports.billing.utility");
                        break;
                    default:
                        type = row.type;
                        break;
                }

                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 h2">{type}</span>
                        </p>
                    </div>
                );
            }
        },
        {
            name: t("reports.billing.currently"),
            sortable: false,
            center: true,
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 bold">{row.currently}</span>
                        </p>

                    </div>
                );
            }
        },
        {
            name: t("reports.billing.last"),
            sortable: false,
            center: true,
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 bold">{row.last}</span>
                        </p>
                    </div>
                );
            }
        },
        {
            name: t("reports.billing.percent"),
            sortable: false,
            center: true,
            cell: (row: any) => {
                const percentage = row.persent === 0
                    ? '0'
                    : row.persent || t("bulk-senders.data-no-info");
                const badgeClass = percentage === '0'
                    ? 'badge bg-soft-warning text-warning'
                    : percentage.startsWith('-')
                        ? 'badge bg-soft-danger text-danger'
                        : percentage.startsWith('+')
                            ? 'badge bg-soft-success text-success'
                            : 'badge bg-soft-warning text-warning';
                const iconClass = percentage === '0'
                    ? ''
                    : percentage.startsWith('-')
                        ? 'bi bi-graph-down-arrow'
                        : percentage.startsWith('+')
                            ? 'bi bi-graph-up-arrow'
                            : '';
                return (
                    <div className="text-left">
                        <p className="mb-0 text-nowrap">
                            <span className={`fs-4 ${badgeClass}`}>
                                {percentage}% {iconClass && <i className={iconClass}></i>}
                            </span>
                        </p>
                    </div>
                );
            }
        }
    ];

    const columnsCampaigns = [
        {
            name: t("reports.billing.campaigns"),
            sortable: false,
            center: false,
            selector: (row: any) => row.campaign,
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 h1">{row.campaign}</span>
                        </p>
                    </div>
                );
            }
        },
        {
            name: t("date"),
            sortable: false,
            center: false,
            selector: (row: any) => row.date,
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 h1">{row.date}</span>
                        </p>

                    </div>
                );
            }
        },
        {
            name: t("reports.billing.sents"),
            sortable: false,
            center: true,
            selector: (row: any) => NumberUtil.format(row.sents),
            cell: (row: any) => {
                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 fw-bold text-primary">{NumberUtil.format(row.sents)}</span>
                        </p>
                    </div>
                );
            }
        },
        {
            name: t("reports.billing.errors"),
            sortable: false,
            center: true,
            selector: (row: any) => NumberUtil.format(row.failed),
            cell: (row: any) => {

                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 fw-bold text-danger">{NumberUtil.format(row.failed)}</span>
                        </p>
                    </div>
                );
            }
        },
        {
            name: t("reports.billing.answers"),
            sortable: false,
            center: true,
            selector: (row: any) => {
                const rateResponse = parseFloat(row.rate_response);
                return isNaN(rateResponse) ? '0.00 %' : `${rateResponse.toFixed(2)} %`;
            },
            cell: (row: any) => {
                const rateResponse = parseFloat(row.rate_response);
                return (
                    <div className="text-left">
                        <p className="mb-0">
                            <span className="fs-4 fw-bold text-primary"> {isNaN(rateResponse) ? '0.00 %' : `${rateResponse.toFixed(2)} %`}</span>
                        </p>
                    </div>
                );
            }
        }
    ];

    const getConvesations = async (accountId: number) => {

        if (filterRangeDates.start && filterRangeDates.end) {
            const init_date = filterRangeDates.start.format('YYYY-MM-DD')
            const end_date = filterRangeDates.end.format('YYYY-MM-DD')
            const dataNormal = [];
            if (session.profile === 'Root') {
                const { data } = await call(() => BillingService.getConversations(accountId, init_date, end_date));
                setDataRoot(data)
            } else {
                const { data } = await call(() => BillingService.getConversations(account.id, init_date, end_date));
                const conversationsData = Object.keys(data[0].chart).map((date) => {
                    const chartData = data[0].chart[date];
                    return {
                        day: date,
                        AUTHENTICATION: chartData.AUTHENTICATION,
                        MARKETING: chartData.MARKETING,
                        SERVICE: chartData.SERVICE,
                        UTILITY: chartData.UTILITY,
                    };
                });
                setConversations(conversationsData);
                Object.keys(data[0].table).forEach((key) => {
                    dataNormal.push({
                        type: key,
                        currently: data[0].table[key].currently,
                        last: data[0].table[key].last,
                        persent: data[0].table[key].persent
                    });
                });
                setData(dataNormal);
            }
        }
    }

    const getTemplates = async (accountId: number) => {
        if (!filterRangeDates.start || !filterRangeDates.end) return;

        const init_date = filterRangeDates.start.format('YYYY-MM-DD');
        const end_date = filterRangeDates.end.format('YYYY-MM-DD');
        const accounID = session.profile === 'Root' ? accountId : account.id;

        try {
            const { data } = await call(() => BillingService.getTargets(accounID, init_date, end_date));
            setTotalCampaigns(NumberUtil.format(+data.campaign.total));
            setTotalApi(NumberUtil.format(+data.api.total));
            setTotalChat(NumberUtil.format(+data.chats.total));

            setDataTargets({
                campaign: { ...data.campaign, data_points: data.campaign.data_points },
                api: { ...data.api, data_points: data.api.data_points },
                chats: { ...data.chats, data_points: data.chats.data_points }
            });
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    };

    const getResume = async (accountId: number, app: string) => {
        if (filterRangeDates.start && filterRangeDates.end) {
            const init_date = filterRangeDates.start.format('YYYY-MM-DD');
            const end_date = filterRangeDates.end.format('YYYY-MM-DD');
            const accounID = session.profile === 'Root'
                ? (accountId !== null ? accountId : undefined)
                : (accountId !== null ? accountId : account.id);


            const { data } = await call(() => BillingService.getResume(accounID, init_date, end_date, app));
            setTotalTargets(data.length);
            const labels = data.map((item: any) => item.campaign);
            const dataPoints = data.reduce((acc: { [key: string]: number }, item: any) => {
                acc[item.campaign] = item.sents;
                return acc;
            }, {});

            setDataTags({
                labels,
                dataPoints,
            });
            setDataRCS(data);
        }
    };

    const getTemplatesSend = async (accountId: number, app: string) => {
        if (!filterRangeDates.start || !filterRangeDates.end) return;

        const init_date = filterRangeDates.start.format('YYYY-MM-DD');
        const end_date = filterRangeDates.end.format('YYYY-MM-DD');

        const accounID = session.profile === 'Root'
            ? (accountId !== null ? accountId : undefined)
            : (accountId !== null ? accountId : account.id);

        try {
            const { data } = await call(() => BillingService.getSendTemplates(accounID, init_date, end_date, app));
            setTotalCamp(NumberUtil.format(+data.campaign.total));

            setDataTargets({
                campaign: { ...data.campaign, data_points: data.campaign.data_points },
                api: { ...data.api, data_points: data.api.data_points },
                chats: { ...data.chats, data_points: data.chats.data_points }
            });
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    };


    const handleTabClick = (tab: string) => {
        setActiveTab(tab);
    };

    const createGradient = (ctx: any, color: any) => {
        let gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
        gradient.addColorStop(0, `${color}0.5)`);
        gradient.addColorStop(1, `${color}0.0)`);
        return gradient;
    };

    const backgroundColorConfig = {
        customers: 'rgba(55, 125, 255, ',
        business: 'rgba(255, 159, 64, ',
        service: 'rgba(153, 102, 255, ',
        utility: 'rgba(75, 192, 192, '
    };

    const createBackgroundColor = (type) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        return createGradient(ctx, backgroundColorConfig[type]);
    };



    useEffect(() => {
        const fetchData = async () => {
            try {
                if (activeTab === "tabOne") {
                    await getTemplates(selectedAccount);
                    await getConvesations(selectedAccount);
                } else {
                    const messageType = activeTab === "tabTwo" ? 'RCS' : 'SMS';
                    await getTemplatesSend(selectedAccount, messageType);
                    await getResume(selectedAccount, messageType);
                }
            } catch (error: any) {
                AlertService.toastError(t("reports.billing.text-error"), error);
            }
        };

        fetchData();
    }, [selectedAccount, filterRangeDates]);


    useEffect(() => {
        setDatePickerKey((prevKey) => prevKey + 1);
        setFilterRangeDates({ start: moment().subtract(6, 'days'), end: moment() });
    }, [activeTab]);


    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("reports.operation-title")}</span></li>
                                        <li className="breadcrumb-item " aria-current="page"><span className="breadcrumb-link" >{t("reports.reports-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("reports.billing.billing-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title"><i className="bi-grid-1x2 nav-icon"></i> {t("reports.reports-title")} - {t("reports.billing.billing-title")}</h1>
                            </div>
                            <div className="col-sm-auto">
                                {session.profile === 'Root' && (
                                    <Select
                                        options={accounts.map(a => ({ value: a.account_id, label: a.nombre }))}
                                        className={'form-select-custom width-select'}
                                        classNamePrefix='form-select-custom'
                                        value={accounts.find(a => a.account_id === selectedAccount) ? { value: selectedAccount, label: accounts.find(a => a.account_id === selectedAccount).nombre } : null}
                                        onChange={(selectedOption) => setSelectedAccount(selectedOption ? selectedOption.value : null)}
                                        placeholder={t("reports.billing.select-placeholder")}
                                        isClearable
                                    />
                                )}

                            </div>
                            <div className="col-sm-auto">

                                <DatePicker
                                    key={datePickerKey}
                                    onDatesChange={setFilterRangeDates}
                                    filterDay={6}
                                />
                            </div>
                        </div>
                        <ul className="nav nav-tabs page-header-tabs">
                            <li className="nav-item">
                                <a className={`nav-link cursor-pointer ${activeTab === 'tabOne' ? 'active' : ''}`} onClick={() => handleTabClick('tabOne')}><i className="bi-whatsapp"></i> WhatsApp</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link cursor-pointer ${activeTab === 'tabTwo' ? 'active' : ''}`} onClick={() => handleTabClick('tabTwo')}><i className="bi-chat-left"></i> RCS</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link cursor-pointer ${activeTab === 'tabThree' ? 'active' : ''}`} onClick={() => handleTabClick('tabThree')}><i className="bi-chat-square-text"></i> SMS</a>
                            </li>
                        </ul>
                    </div>
                    {activeTab === 'tabOne' && (
                        <>
                            <div className={`relative ${heightRequesting}`}>
                                {isRequesting ? (
                                    <LoaderSmall />
                                ) : (
                                    <div className="row">
                                        <div className="col-sm-6 col-lg-4 mb-3 mb-lg-5">
                                            <a className="card card-hover-shadow h-100" href="#">
                                                <div className="card-body">
                                                    <h6 className="card-subtitle">
                                                        {t("reports.billing.target-campaigns")}
                                                    </h6>
                                                    <div className="row align-items-center gx-2 mb-1">
                                                        <div className="col-7">
                                                            <h1 className="card-title">
                                                                {totalCampaigns}
                                                            </h1>
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="chartjs-custom">
                                                                <SimpleLineChart
                                                                    labels={Object.keys(dataTargets.campaign.data_points)}
                                                                    dataPoints={dataTargets.campaign.data_points}
                                                                    title={t("reports.billing.campaigns")}
                                                                    width={180}
                                                                    height={70}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-sm-6 col-lg-4 mb-3 mb-lg-5">
                                            <a className="card card-hover-shadow h-100" href="#">
                                                <div className="card-body">
                                                    <h6 className="card-subtitle">
                                                        {t("reports.billing.target-api")}
                                                    </h6>
                                                    <div className="row align-items-center gx-2 mb-1">
                                                        <div className="col-6">
                                                            <h1 className="card-title">
                                                                {totalApi}
                                                            </h1>
                                                        </div>
                                                        <div className="col-6">
                                                            <div className="chartjs-custom">
                                                                <SimpleLineChart
                                                                    labels={Object.keys(dataTargets.api.data_points)}
                                                                    dataPoints={dataTargets.api.data_points}
                                                                    title="API"
                                                                    width={180}
                                                                    height={70}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-sm-6 col-lg-4 mb-3 mb-lg-5">
                                            <a className="card card-hover-shadow h-100" href="#">
                                                <div className="card-body">
                                                    <h6 className="card-subtitle">
                                                        {t("reports.billing.target-chat")}
                                                    </h6>
                                                    <div className="row align-items-center gx-2 mb-1">
                                                        <div className="col-7">
                                                            <h1 className="card-title">
                                                                {totalChat}
                                                            </h1>
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="chartjs-custom">
                                                                <SimpleLineChart
                                                                    labels={Object.keys(dataTargets.chats.data_points)}
                                                                    dataPoints={dataTargets.chats.data_points}
                                                                    title="Chat"
                                                                    width={180}
                                                                    height={70}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <span className={`divider-${session.profile === 'Root' ? 'center' : 'start'} text-primary fs-3`}>
                                {t("reports.billing.divider")}
                            </span>
                            <div className='row mt-3 p-2'>
                                {session.profile === 'Root' ? (
                                    <CustomDataTable
                                        columns={columnsRoot}
                                        data={dataRoot}
                                        hideAccountsFilter
                                        showExport={false}
                                        isLoading={isRequesting}
                                        onDatesChange={(range) => setFilterRangeDates(range)}
                                        filter={(row, term) => {
                                            if (!term) return true;
                                            const matchTable = Object.values(row.table).some((tableObj) =>
                                                Object.values(tableObj).some((value) =>
                                                    `${value}`.match(new RegExp(`${term}`, 'i'))
                                                )
                                            );
                                            return (
                                                `${row.account}`.match(new RegExp(`${term}`, 'i')) ||
                                                `${row.account_client}`.match(new RegExp(`${term}`, 'i')) ||
                                                matchTable
                                            );
                                        }}
                                    />
                                ) :
                                    (
                                        <div className="row">
                                            <div className="col-lg-5 mb-3 mb-lg-5">
                                                <div className="h-100">
                                                    <CustomDataTable
                                                        columns={columns}
                                                        data={data}
                                                        hideAccountsFilter
                                                        showExport={false}
                                                        isLoading={isRequesting}
                                                        onDatesChange={(range) => setFilterRangeDates(range)}
                                                        filter={(row, term) => {
                                                            if (!term) return true;
                                                            return (
                                                                `${row.type}`.match(new RegExp(`${term}`, 'i')) ||
                                                                `${row.currently}`.match(new RegExp(`${term}`, 'i')) ||
                                                                `${row.last}`.match(new RegExp(`${term}`, 'i')) ||
                                                                `${row.persent}`.match(new RegExp(`${term}`, 'i'))
                                                            );
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-lg-7 mb-3 mb-lg-5">
                                                <div className="card h-100">
                                                    <div className="card-header card-header-content-between">
                                                        <h4 className="card-header-title">
                                                            {t("reports.billing.conversations")}
                                                            <i
                                                                className="bi-whatsapp text-primary ms-2"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                                title="This report is based on 100% of sessions."
                                                            />
                                                        </h4>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className={` ${heightRequesting}`}>
                                                            {isRequesting ? (
                                                                <LoaderSmall />
                                                            ) : (
                                                                <div className="w-full">
                                                                    <LineChart
                                                                        labels={conversations.map(t => t.day)}
                                                                        width={'100%'}
                                                                        height={350}
                                                                        datasets={[
                                                                            { label: t("reports.billing.auth"), data: conversations.map(t => t.AUTHENTICATION), backgroundColor: createBackgroundColor('customers'), borderColor: "#377dff", borderWidth: 2, tension: 0.4, pointRadius: 2, pointHoverRadius: 2, fill: true },
                                                                            { label: t("reports.billing.mkt"), data: conversations.map(t => t.MARKETING), backgroundColor: createBackgroundColor('business'), borderColor: "#ff9f40", borderWidth: 2, tension: 0.4, pointRadius: 2, pointHoverRadius: 2, fill: true },
                                                                            { label: t("reports.billing.service"), data: conversations.map(t => t.SERVICE), backgroundColor: createBackgroundColor('service'), borderColor: "#9966ff", borderWidth: 2, tension: 0.4, pointRadius: 2, pointHoverRadius: 2, fill: true },
                                                                            { label: t("reports.billing.utility"), data: conversations.map(t => t.UTILITY), backgroundColor: createBackgroundColor('utility'), borderColor: "#4bc0c0", borderWidth: 2, tension: 0.4, pointRadius: 2, pointHoverRadius: 2, fill: true }
                                                                        ]}
                                                                        legendDisplay={false}
                                                                    />

                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    )}
                    {(activeTab === 'tabTwo' || activeTab === 'tabThree') && (
                        <>
                            <div className={`relative ${heightRequesting}`}>
                                {isRequesting ? (
                                    <LoaderSmall />
                                ) : (
                                    <div className="row">
                                        <div className="col-sm-6 col-lg-4 mb-3 mb-lg-5">
                                            <a className="card card-hover-shadow h-100" href="#">
                                                <div className="card-body">
                                                    <h6 className="card-subtitle">
                                                        {t("reports.billing.title-card-1")}
                                                    </h6>
                                                    <div className="row align-items-center gx-2 mb-1">
                                                        <div className="col-7">
                                                            <h1 className="card-title">
                                                                {totalTargets}
                                                            </h1>
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="chartjs-custom">
                                                                <SimpleLineChart
                                                                    labels={dataTags.labels}
                                                                    dataPoints={dataTags.dataPoints}
                                                                    title={'Envíos'}
                                                                    width={480}
                                                                    height={70}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-sm-6 col-lg-4 mb-3 mb-lg-5">
                                            <a className="card card-hover-shadow h-100" href="#">
                                                <div className="card-body">
                                                    <h6 className="card-subtitle">
                                                        {t("reports.billing.target-campaigns")}
                                                    </h6>
                                                    <div className="row align-items-center gx-2 mb-1">
                                                        <div className="col-7">
                                                            <h1 className="card-title">
                                                                {totalCamp}
                                                            </h1>
                                                        </div>
                                                        <div className="col-5">
                                                            <div className="chartjs-custom">
                                                                <SimpleLineChart
                                                                    labels={Object.keys(dataTargets.campaign.data_points)}
                                                                    dataPoints={dataTargets.campaign.data_points}
                                                                    title={t("reports.billing.campaigns")}
                                                                    width={180}
                                                                    height={70}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <span className="divider-start text-primary fs-3">
                                {t("reports.billing.divider-2")}
                            </span>
                            <div className='row mt-3 p-2'>
                                <CustomDataTable
                                    columns={columnsCampaigns}
                                    data={dataRCS}
                                    hideAccountsFilter
                                    showExport={true}
                                    isLoading={isRequesting}
                                    onDatesChange={(range) => setFilterRangeDates(range)}
                                    filter={(row, term) => {
                                        if (!term) return true;
                                        const matchTable = Object.values(row.table).some((tableObj) =>
                                            Object.values(tableObj).some((value) =>
                                                `${value}`.match(new RegExp(`${term}`, 'i'))
                                            )
                                        );
                                        return (
                                            `${row.account}`.match(new RegExp(`${term}`, 'i')) ||
                                            `${row.account_client}`.match(new RegExp(`${term}`, 'i')) ||
                                            matchTable
                                        );
                                    }}
                                />
                            </div>
                        </>
                    )}

                </div>
                <Footer />
            </main>
        </>
    )
}
export default BillingPage